'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'lungs';
var width = 640;
var height = 512;
var aliases = [129729];
var unicode = 'f604';
var svgPathData = 'M640 419.8C640 472.1 594.4 512 541.9 512c-18 0-24.41-2.872-86.66-19.5c-42.13-11.38-71.25-47.5-71.25-88.63L384 322.5l48 34.3v47.06c0 19.25 14.62 36.63 35.63 42.25C532.3 463.4 532.1 464 541.9 464c30.38 0 58-23.62 47.88-61.5c-20.38-76.63-52.75-149.8-96.13-217.5C470.6 148.6 468.4 144 453.1 144C442.1 144 432 152.1 432 161.8V258.5l69.95 49.97c10.78 7.719 13.28 22.69 5.578 33.47C502.8 348.5 495.5 352 487.1 352c-4.828 0-9.703-1.438-13.94-4.469L320 237.5l-154 110.1C161.7 350.6 156.8 352 152 352c-7.484 0-14.86-3.5-19.55-10.06c-7.703-10.78-5.203-25.75 5.578-33.47L208 258.5V161.8C208 152.1 197.9 144 185.1 144c-14.37 0-16.62 4.625-39.62 41C103 252.8 70.63 325.9 50.25 402.5C40.13 440.4 67.75 464 98.13 464c9.75 0 9.625-.625 74.25-17.88C193.4 440.5 208 423.1 208 403.9v-47.06L256 322.5l.0313 81.36c0 41.13-29.12 77.25-71.25 88.63C122.5 509.1 116.1 512 98.13 512C45.63 512 0 472.1 0 419.8c0-10 1.25-19.88 3.875-29.63c21.62-81.25 56.03-159.1 102-231c22.12-34.63 36.12-63.13 80.12-63.13C224.7 96 256 125.4 256 161.8v62.46l36.64-26.18C294.8 196.5 296 194.1 296 191.5V24C296 10.75 306.8 0 320 0s23.1 10.75 23.1 24v167.5c0 2.562 1.25 5 3.359 6.5L384 224.2V161.8c0-36.38 31.34-65.75 69.97-65.75c43.1 0 58 28.5 80.13 63.13c46 71.88 80.41 149.8 102 231C638.8 399.9 640 409.8 640 419.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLungs = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;